function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import ContextMenu from './ContextMenu';
import Portal from "./Portal";
// Set to true to debug this file
const DEBUG = false;
export default class Wrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      display: undefined,
      width: undefined,
      coords: [0, 0]
    };
    this.ref = /*#__PURE__*/React.createRef();
    this.menuRef = /*#__PURE__*/React.createRef();
  }
  static getDerivedStateFromError(error) {
    return {
      error: error
    };
  }
  componentDidMount() {
    try {
      let display = window.getComputedStyle(this.ref.current.childNodes[0], null).display;
      let width = window.getComputedStyle(this.ref.current.childNodes[0], null).width;
      if (this.state.display !== display || this.state.width !== width) {
        DEBUG && console.log("Wrapper", this.state.display, "->", display, "; ", this.state.width, "->", width);
        this.setState({
          display: display,
          width: width
        });
      }
    } catch (e) {
      DEBUG && console.log("Wrapper e", e);
    }
  }
  render() {
    let Component = this.props.Component || (this.props["data-tag-name"] === "MathJax" ? "span" : "div");
    if (this.state.error) {
      return /*#__PURE__*/React.createElement("div", {
        className: "error-fallback"
      }, this.state.error);
    }
    DEBUG && console.log("Wrapper render", this.ref);
    let {
      children,
      ...rest
    } = this.props;
    const childrenWithProps = React.Children.map(this.props.children, data => {
      if ( /*#__PURE__*/React.isValidElement(data)) {
        if (typeof data.type === "string") {
          //return React.cloneElement(data, rest)
        }
      }
      return /*#__PURE__*/React.createElement("div", {
        style: {
          position: "relative"
        }
      }, /*#__PURE__*/React.createElement(Component, _extends({
        onContextMenu: e => {
          if (e.altKey) {
            e.preventDefault();
            this.setState({
              coords: [e.clientX, e.clientY]
            });
            this.props.setMenuStates(this.props.index, true);
          }
        },
        ref: this.ref,
        style: {
          display: this.state.display,
          width: this.state.width
        }
      }, rest), data), /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement(ContextMenu, {
        active: this.props.menuState,
        index: this.props.index,
        setMenuStates: this.props.setMenuStates,
        coords: this.state.coords,
        component: this.ref.current,
        data: this.props.data
      })));
    });
    return childrenWithProps;
  }
}